﻿import {UIBase} from "../Tools/Base/UIBase";

export class UILoader extends UIBase {

    Awake() {
        super.Awake();
        this.progress = null; // RectTransform progress;
        this.progressVal = 0;
        this.complete = false;
    }

    Show() {
        super.Show();
        this.progressVal = 0;
    }

    SetComplete() {
        this.complete = true;
        this.progressVal = 1;
    }

    Update() {
//        progressVal += (Time.deltaTime * 0.2f * Random.Range(0.1f, 2f)) * Mathf.Clamp(1f - progressVal * 1.5f, 0.01f, 1f);
//
//        if (complete)
//        {
//            progressVal = Mathf.Clamp01(progressVal);
//        }
//        else
//        {
//            progressVal = Mathf.Clamp(progressVal, 0, 0.8f);
//        }
//
//        progress.anchorMax = new Vector2(progressVal, 1f);
//        progress.offsetMax = Vector3.zero;
    }
}
